// extracted by mini-css-extract-plugin
export var heroImage = "_g0-1";
export var modal = "_g0-0";